/**
 * Wrap each element in items based on it's index into a masonry template.
 * This way you can define a specific layout in a masonry template
 * and ensure that every item you attach dynamically stays in this layout.
 * @param {Element[]} items
 * @param {jQuery} $templates
 * @returns {Element[]}
 */
const mapItemsToTemplates = (items, $templates) => (
    items.map((item, index) => (
        $templates
            .eq(index % $templates.length)
            .clone()
            .children()
            .append(item)
            .parent()
            .get(0)
        )
    )
);

export default mapItemsToTemplates;



// WEBPACK FOOTER //
// ./src/scripts/components/masonry/mapItemsToTemplates.js